import React, { useContext } from 'react';
import {
  Modal,
  Portal,
} from 'react-native-paper';
import { NativeBaseProvider, View } from 'native-base';
import { useQuery } from '@apollo/client';
import {
  Text,
} from 'react-native';
import { ModalContext } from '../../context/ModalContext';
import { FindOneEvent } from '../../gql/event/query';
import LoadingIndicator from '../../components/commons/LoadingIndicator';
import ZoomableImage from '../../components/commons/ZoomableImage';

function Picture() {
  const modalContext = useContext(ModalContext);

  if (!modalContext) {
    console.error('ModalContext is null or undefined. Ensure Picture component is wrapped by ModalProvider.');
    return null;
  }

  const { displayPictureModal } = modalContext;
  const { togglePictureModal } = modalContext;

  const { data, loading, error } = useQuery(
    FindOneEvent,
    {
      variables: {
        id: Number(displayPictureModal?.eventId),
      },
    },
  );

  if (!displayPictureModal.display) return null;

  const base64file = displayPictureModal.isInfoMedia
    ? data?.findOneEvent?.infoMedia
    : data?.findOneEvent?.media;

  return (
    <Modal
      visible={displayPictureModal.display}
      onDismiss={togglePictureModal}
      dismissableBackButton
      style={{
        elevation: 0,
        borderColor: 'transparent',
      }}
    >
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        {loading ? (
          <LoadingIndicator text="Chargement du document..." />
        ) : error ? (
          <Text>
            Error loading image:
            {error.message}
          </Text> // Display error message
        ) : (
          <ZoomableImage source={{ uri: base64file }} />
        )}
      </View>
    </Modal>
  );
}

export default function PictureModal() {
  return (
    <Portal style={{ boxShadow: 0 }}>
      <NativeBaseProvider style={{ boxShadow: 0 }}>
        <Picture />
      </NativeBaseProvider>
    </Portal>
  );
}
